module.exports = __webpack_public_path__ + "img/1.1.b74a5b7e.png";